import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION_TYPE } from "@demandproai/shared";
import { useNotificationContext } from "../contexts/NotificationContext";

const PAGE_SIZE = 10;

const useNotificationBell = () => {
    const {
        isOpen, toggleOpen, closeDropdown,
        notifications, unreadCount, markAsRead, getNotifications,
        totalItems, totalPages
    } = useNotificationContext();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target) && isOpen) {
                closeDropdown();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, closeDropdown]);

    // every bell click refetches so the counter and list reflect server state, including close-clicks
    const handleBellClick = () => {
        setPage(1);
        getNotifications({ page: 1, limit: PAGE_SIZE });
        toggleOpen();
    };

    const handlePageChange = (nextPage) => {
        setPage(nextPage);
        getNotifications({ page: nextPage, limit: PAGE_SIZE });
    };

    const handleNotificationClick = ({ caseId, notificationId, isRead, notificationType }) => {
        if (!isRead) markAsRead({ caseId, notificationId });
        closeDropdown();
        const destination = notificationType === NOTIFICATION_TYPE.NOTE_ADDED
            ? `/case/summary/${caseId}`
            : `/cases?search=${caseId}`;
        navigate(destination);
    };

    const startIndex = totalItems === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
    const endIndex = (page - 1) * PAGE_SIZE + (notifications?.length ?? 0);

    return {
        wrapperRef, isOpen, handleBellClick, unreadCount, handleNotificationClick,
        pageItems: notifications ?? [],
        page, totalPages, startIndex, endIndex,
        totalCount: totalItems,
        handlePageChange
    };
};

export default useNotificationBell;
